export function getNonUmbracoUrl(
  url?: string,
  preserveLocale: boolean = false,
) {
  if (!url) {
    return "/"
  }
  if (url?.includes("pages/home")) {
    return "/"
  }
  // Check if URL is absolute (starts with protocol)
  if (url?.match(/^https?:\/\//)) {
    return url
  }
  if (!url?.includes("pages")) {
    return url
  }

  // Check if URL starts with a locale (e.g., /en/, /ar/, etc.)
  const localeMatch = url.match(/^\/([a-z]{2})\//)
  const locale = localeMatch ? localeMatch[1] : null

  // Remove everything up to and including /pages/
  let processedUrl = url.replace(/.*\/pages/, "")

  // If we had a locale prefix and preserveLocale is true, add it back
  if (locale && preserveLocale) {
    processedUrl = `/${locale}${processedUrl}`
  }

  return processedUrl
}
